module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Rob Sinclair\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_c('P', [_vm._v("Rob is the author of the acclaimed and bestselling Enemy and James Ryker series of espionage thrillers. His books have sold over half a million copies with many reviewers and readers having likened Rob’s work to authors at the very top of the genre, including Lee Child and Vince Flynn. Rob began writing in 2009 following a promise to his wife that he could pen a ‘can’t put down’ thriller. He worked for nearly 13 years for a global firm specialising in forensic fraud investigations. Rob now writes full time.")])], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/uwK0jw/tc-custom/9781788635011.jpg?1728724815757",
      "alt": "This image is the cover for the book Essence of Evil, DI Dani Stephens"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Essence of Evil, DI Dani Stephens\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_c('b', [_vm._v("To gain insight on a string of murders, a Birmingham DI consults with her twin who almost killed her in this crime thriller series debut.")])]), _c('p', [_vm._v(" When DI Dani Stephens returns to work after an attack that almost ended her life, she’s quickly plunged into a horrific new case, as dead bodies are discovered on the streets of Birmingham. ")]), _c('p', [_vm._v(" But with no link between the victims, Dani must get inside the killer’s mind—so she turns to the murderer she knows best. Her own twin brother . . . ")]), _c('p', [_vm._v(" But what makes a psychopath? Can understanding her twin help her find a murderer who leaves no trace? As the circle closes on Dani, the clock is ticking, and she needs a breakthrough—before she becomes the latest victim. ")]), _c('p', [_c('b', [_vm._v("A great choice for fans of Peter James and Mark Billingham.")])]), _vm._v(" "), _c('p')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Canelo Digital Publishing Limited\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cb664236","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0